import toast from "react-hot-toast"

export const showToast = {
  _isShowToast: true,
  success: (msg) => toast.success(msg, { duration: 3000 }),
  error: (msg) => toast.error(msg, { duration: 4000 }),
  warn: (msg) => toast(msg, { duration: 3000, icon: "⚠️" }),
  info: (msg) => toast(msg, { duration: 3000 }),
  loading: (msg) => toast.loading(msg),
  dismiss: (id) => toast.dismiss(id),
}
